define.alias("shared/components/shared/image", "media/components/shared/image");